(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ob-fitting-schedule"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ob-fitting-schedule')) {
    class ObFittingSchedule extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.locale = this.dataset.locale === 'en' ? 'en-US' : 'ja-JP';
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
        const part = (type) => parts.find((item) => item.type === type).value;
        this.today = `${part('year')}-${part('month')}-${part('day')}`;
        this.cards = [...this.querySelectorAll('[data-event-date]')].sort((a, b) => a.dataset.eventDate.localeCompare(b.dataset.eventDate));
        this.upcoming = this.cards.filter((card) => card.dataset.eventDate >= this.today);
        this.querySelector('.ob-schedule__list').append(...this.cards);
        const currentMonth = this.today.slice(0, 7);
        const firstDate = this.upcoming.some((card) => card.dataset.eventDate.startsWith(currentMonth)) ? this.today : this.upcoming[0]?.dataset.eventDate || this.today;
        this.year = Number(firstDate.slice(0, 4));
        this.month = Number(firstDate.slice(5, 7)) - 1;
        this.selected = null;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-shift')) {
            const date = new Date(Date.UTC(this.year, this.month + Number(button.dataset.shift), 1));
            this.year = date.getUTCFullYear();
            this.month = date.getUTCMonth();
            this.selected = null;
          } else if (button.hasAttribute('data-current')) {
            this.year = Number(this.today.slice(0, 4));
            this.month = Number(this.today.slice(5, 7)) - 1;
            this.selected = null;
          } else if (button.dataset.day) {
            this.selected = this.selected === button.dataset.day ? null : button.dataset.day;
          } else if (button.hasAttribute('data-reset')) {
            this.selected = null;
          } else return;
          const focusDay = button.dataset.day;
          this.render();
          if (focusDay) this.querySelector(`[data-day="${focusDay}"]`)?.focus();
        });
        this.querySelector('.ob-schedule__calendar').hidden = false;
        this.render();
      }
      render() {
        const prefix = `${this.year}-${String(this.month + 1).padStart(2, '0')}`;
        const formatter = new Intl.DateTimeFormat(this.locale, { timeZone: 'UTC', year: 'numeric', month: 'long' });
        const label = formatter.format(new Date(Date.UTC(this.year, this.month, 1)));
        this.querySelector('.ob-schedule__month').textContent = label;
        const table = document.createElement('table');
        table.setAttribute('aria-label', label);
        const headRow = table.createTHead().insertRow();
        this.dataset.weekdays.split(',').forEach((day) => {
          const th = document.createElement('th');
          th.scope = 'col';
          th.textContent = day;
          headRow.append(th);
        });
        const body = table.createTBody();
        const offset = new Date(Date.UTC(this.year, this.month, 1)).getUTCDay();
        const days = new Date(Date.UTC(this.year, this.month + 1, 0)).getUTCDate();
        const cellCount = Math.ceil((offset + days) / 7) * 7;
        let row;
        for (let index = 0; index < cellCount; index += 1) {
          if (index % 7 === 0) row = body.insertRow();
          const cell = row.insertCell();
          const day = index - offset + 1;
          if (day < 1 || day > days) continue;
          const iso = `${prefix}-${String(day).padStart(2, '0')}`;
          const events = this.upcoming.filter((card) => card.dataset.eventDate === iso);
          const element = document.createElement(events.length ? 'button' : 'span');
          element.textContent = String(day);
          if (iso === this.today) element.setAttribute('aria-current', 'date');
          if (events.length) {
            element.type = 'button';
            element.dataset.day = iso;
            element.setAttribute('aria-pressed', String(this.selected === iso));
            element.setAttribute('aria-label', `${iso}: ${this.dataset.sessionLabel} — ${[...new Set(events.map((card) => card.dataset.eventArea))].join(', ')}`);
          }
          cell.append(element);
        }
        this.querySelector('.ob-schedule__table-wrap').replaceChildren(table);
        let visibleCount = 0;
        this.cards.forEach((card) => {
          const date = card.dataset.eventDate;
          const visible = date >= this.today && date.startsWith(prefix) && (!this.selected || date === this.selected);
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        this.querySelector('.ob-schedule__empty').hidden = visibleCount > 0;
        this.querySelector('[data-reset]').hidden = !this.selected;
      }
    }
    customElements.define('ob-fitting-schedule', ObFittingSchedule);
  }

  } catch(e) { console.error(e); }
})();
})();
